import Button from "@edaz/edazkit/Button/index";
import AdvancedSelect from "@edaz/edazkit/controls/AdvancedSelect";
import { IconType } from "@edaz/edazkit/Icon";
import type { ViewComponent } from "@frui.ts/views";
import { preventDefault, registerView } from "@frui.ts/views/dist";
import { observer } from "mobx-react-lite";
import React from "react";
import { Col, Form, Row } from "react-bootstrap";
import { translateGeneral } from "utils/localizations";
import RevenuesReportsViewModel from "viewModels/finance/expensesAndRevenuesReports/revenuesReportsViewModel";
import FormLabel from "controls/formLabel";
import { busyIdentificator } from "utils/busyWatcher";

const RevenuesReportsView: ViewComponent<RevenuesReportsViewModel> = observer(({ vm }) => {
  const isDownloadBusy = vm.busyWatcher.checkBusy(busyIdentificator([vm.selectedMonth, vm.revenueSourceType]));

  return (
    <>
      <Form className="mb-4" onSubmit={preventDefault(vm.onFormSubmit)}>
        <Row>
          <Col as={Form.Group} sm={6} md={4}>
            <FormLabel required={true}>{vm.translate("date")}</FormLabel>
            <AdvancedSelect target={vm} property="selectedDate" items={vm.months} placeholder={translateGeneral("select")} />
          </Col>
          <Col as={Form.Group} sm={6} md={4}>
            <FormLabel required={true}>{vm.translate("revenueSourceType")}</FormLabel>
            <AdvancedSelect
              target={vm}
              property="revenueSourceType"
              items={vm.revenueSourceTypes}
              placeholder={translateGeneral("select")}
            />
          </Col>
          <Col md="auto">
            <Button
              className="mt-md-5 rounded d-block"
              type="submit"
              disabled={isDownloadBusy || !vm.selectedMonth || !vm.revenueSourceType}
              iconLeft={isDownloadBusy ? IconType.Spinner : IconType.Download}>
              {translateGeneral("download")}
            </Button>
          </Col>
        </Row>
      </Form>
      <div className="mt-4">
        <table className="table table-striped table-full">
          {vm.items.map(revenueSourceType => {
            const month = vm.months[0];
            const isBusy = vm.busyWatcher.checkBusy(busyIdentificator([month.month, revenueSourceType]));

            return (
              <tr key={revenueSourceType}>
                <td>
                  <strong className="pr-3">{month.label}</strong> {vm.translateSourceType(revenueSourceType)}
                </td>
                <td className="text-align-end">
                  <Button
                    variant="success"
                    size="sm"
                    className="rounded"
                    disabled={isBusy}
                    iconLeft={isBusy ? IconType.Spinner : IconType.Download}
                    onClick={() => vm.onDownloadClick(month.month, revenueSourceType)}>
                    {translateGeneral("download")}
                  </Button>
                </td>
              </tr>
            );
          })}
        </table>
      </div>
    </>
  );
});

registerView(RevenuesReportsView, RevenuesReportsViewModel);
